export const MAX_LENGTH_TEXTAREA = 300;
